module.exports = __webpack_public_path__ + "media/landosish.8501564d.mp4";